<template>
  <v-card
    id="screenContent"
    class="vetalfa-view secondary"
    :max-width="_getMaxWidth()"
    flat
  >
    <div class="vetalfa-global-header secondary" ref="screenHeader">
      <vetalfa-small-header
        showBreadCrumbAndTitle
        :breadcrumb="_getLabel('SEARCH_TEXT')"
        :title="_getLabel('SEARCH_TEXT')"
      ></vetalfa-small-header>
      <v-row no-gutters justify="center" class="mt-2 pa-0">
        <v-row no-gutters class="vetalfa-max-width">
          <v-col class="ma-0 pa-0 px-3" cols="12">
            <v-text-field
              outlined
              :value="search"
              :disabled="loading"
              v-model="search"
              class="search-bar"
              :placeholder="_getLabel('SEARCH_WHAT_YOU_WANT')"
              ref="searchField"
              :style="{ borderRadius: '28px' }"
              hide-details
              type="text"
              @keyup.enter="searchClick"
            >
              <template v-slot:prepend-inner>
                <v-icon color="primary" class="mr-0">
                  {{ _icon("magnify") }}
                </v-icon>
              </template>

              <template v-slot:append>
                <v-btn
                  :loading="loading"
                  @click="searchClick()"
                  fab
                  color="primary"
                  class="text-none ma-0 pa-0"
                  x-small
                  :disabled="!search"
                >
                  <v-icon color="white" size="22">
                    {{ mdiArrowUp }}
                  </v-icon>
                </v-btn>
              </template>

              <template
                v-if="toggles['ai_search'] && !loading"
                v-slot:append-outer
              >
                <v-row no-gutters align="center" class="vetalfa-row">
                  <v-btn
                    @click="searchWithAI('Button')"
                    fab
                    small
                    color="white"
                  >
                    <v-icon color="primary" class="mr-0" size="24">
                      {{ mdiCreation }}
                    </v-icon>
                  </v-btn>
                </v-row>
              </template>
            </v-text-field>
          </v-col>
          <v-col class="ma-0 pa-0 ml-3 mt-2" cols="12" v-if="results.length">
            <v-chip-group
              v-model="filterModel"
              dense
              :column="!this._isMobile()"
              class="ma-0 pa-0 white--text"
              active-class="primary white--text"
            >
              <v-chip
                v-for="(filter, index) in facets"
                :key="`search-chip-group-${index}`"
                small
                @click="filterClick"
                :outlined="filterModel != index"
                color="primary"
                >{{ filter.name }}</v-chip
              >
            </v-chip-group>
          </v-col>
        </v-row>
      </v-row>
    </div>
    <div ref="screenContent">
      <v-row align="end" justify="start" class="ma-0 pa-0 mt-2 px-3">
        <v-col v-if="!hasSearch && results.length" cols="12" class="ma-0 pa-0">
          <p class="pa-0 ma-0 primary--text font-weight-bold">
            {{ _getLabel("RECENT_SEARCHES") }}
          </p>
        </v-col>
        <v-col v-if="hasSearch && results.length" cols="12" class="ma-0 pa-0">
          <v-alert
            outlined
            border="left"
            rounded
            color="primary"
            class="vetalfa-pointer ma-0 mb-3"
            @click="searchWithAI('Alert')"
            dense
            style="background-color: white !important"
          >
            <v-row align="start" no-gutters>
              <v-col class="grow ma-0 pa-0 subtitle-2 pr-2">
                Tire qualquer dúvida sobre Medicina Veterinária com a nossa
                inteligência artificial.
              </v-col>
              <v-col class="shrink ma-0 pa-0">
                <v-icon x-small color="primary">
                  {{ mdiChevronRight }}
                </v-icon>
              </v-col>
            </v-row>
          </v-alert>
        </v-col>
        <v-col
          cols="12"
          class="ma-0 pa-0 mt-2"
          v-for="(item, index) in results"
          :key="`recentSearches-${index}`"
        >
          <v-card
            @click="openSection(item)"
            class="ma-0 px-2 py-3 vetalfa-card-grey-border vetalfa-pointer"
            min-height="40px"
            flat
          >
            <v-icon
              x-small
              style="position: absolute; top: 42%; right: 8px; translateY(-50%)"
            >
              {{ mdiChevronRight }}
            </v-icon>
            <v-row
              class="ma-0 pa-0"
              align="center"
              :style="{ minHeight: '40px' }"
            >
              <v-col v-if="item.photo" class="ma-0 pa-0 shrink mr-4">
                <v-img
                  :src="item.photo"
                  height="80px"
                  width="80px"
                  contain
                ></v-img>
              </v-col>
              <v-col
                class="ma-0 pa-0"
                :class="{ 'col-11': !item.photo, grow: item.photo }"
              >
                <v-row
                  no-gutters
                  class="subtitle-2"
                  :class="{ 'font-italic': item.type }"
                  :style="{ lineHeight: '16px' }"
                >
                  <span>{{ item.name }}</span>
                </v-row>
                <v-row
                  class="ma-0 pa-0 grey--text text--darken-1 mt-1"
                  :style="{ lineHeight: '10px', fontSize: '10px' }"
                  >{{ getItemDescription(item) }}
                </v-row>
                <v-row v-if="item.snippet" no-gutters class="mt-2">
                  <p
                    v-html="`“${item.snippet.trim()}”`"
                    :style="{ lineHeight: '10px', fontSize: '10px' }"
                    class="ma-0 pa-0"
                  ></p>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-skeleton-loader
        v-if="loading"
        class="ma-0 pa-0"
        :type="skeletonType"
      ></v-skeleton-loader>
      <v-row
        no-gutters
        class="transparent"
        :style="{ height: '200px' }"
      ></v-row>
    </div>
  </v-card>
</template>

<style>
.search-bar {
  background-color: transparent;
}
.search-bar .v-input__control {
  background-color: white;
}
.search-bar .v-input__append-inner {
  background-color: transparent;
  position: absolute !important;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  margin: 0px !important;
}

.search-bar .v-input__append-outer {
  background-color: transparent;
  padding: 0px;
  margin: 8px 0px 0px 16px !important;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import { mdiArrowUp, mdiChevronRight, mdiCreation } from "@mdi/js";
import algoliasearch from "algoliasearch/lite";
import categories from "@/constants/categories.js";
export default {
  name: "Searches",
  data() {
    return {
      facets: [],
      filterModel: undefined,
      searches: [],
      loading: false,
      search: "",
      recentSearches: [],
      hasSearch: false,
      mdiArrowUp,
      mdiChevronRight,
      mdiCreation,
      categories,
      algoliaClient: algoliasearch(
        process.env.VUE_APP_ALGOLIA_PROJECT_ID,
        process.env.VUE_APP_ALGOLIA_SEARCH_KEY
      ).initIndex(process.env.VUE_APP_ALGOLIA_SEARCH_INDEX),
      results: [],
      skeletonType:
        "heading,heading,heading,heading,heading,heading,heading,heading,heading,heading,heading,heading,heading,heading,heading",
    };
  },
  computed: {
    ...mapGetters("general", ["toggles"]),
  },
  created() {
    this.initializeSearchScreen();
  },
  methods: {
    ...mapActions("general", ["logEvent", "routePathRedirect"]),
    ...mapActions("preferences", ["getAndUpdateRecentSearches"]),
    ...mapActions("calculators", ["openCalculatorById"]),
    ...mapActions("topics", ["openTopicItem"]),
    ...mapActions("drugs", ["openItemOrProduct"]),
    getItemDescription(item) {
      return (
        item.description ||
        item.topic ||
        this.categories[item.category - 1].portugueseName
      );
    },
    async searchClick(filterModel) {
      if (!this.search) return;
      const hasFilter = typeof filterModel === "number";
      this.filterModel = hasFilter ? filterModel : undefined;
      const facetFilters = hasFilter
        ? [`categoryName:${this.facets[this.filterModel].name}`]
        : [];
      if (!hasFilter) {
        this.facets = [];
      }

      try {
        this.loading = true;
        this.results = [];
        this.hasSearch = true;
        const results = await this.algoliaClient.search(this.search, {
          facets: ["categoryName"],
          facetFilters,
        });
        if (results.facets && results.facets.categoryName && !hasFilter) {
          this.facets = Object.entries(results.facets.categoryName)
            .map(([name, count]) => ({ name, count }))
            .sort((a, b) => b.count - a.count);
        } else if (!hasFilter) {
          this.facets = [];
        }
        for (let hit of results.hits) {
          const snippet =
            hit._snippetResult && hit._snippetResult.content // &&
              ? // hit._snippetResult.content.matchLevel !== "none"
                hit._snippetResult.content.value
              : null;
          this.results.push({
            name: hit.itemName,
            photo: hit.photo || undefined,
            id: hit.itemId,
            description: hit.categoryName,
            path: hit.itemPath,
            type: hit.itemType || null,
            snippet,
          });
        }
      } finally {
        this.loading = false;
        this.setupScreenSizes();
      }
    },
    filterClick() {
      this.$nextTick(() => {
        this.searchClick(this.filterModel);
      });
    },
    async initializeSearchScreen() {
      try {
        this.loading = true;
        this.recentSearches = await this.getAndUpdateRecentSearches();
      } catch {
        this.recentSearches = [];
      } finally {
        this.loading = false;
        this.results = [...this.recentSearches];
        this.setupScreenSizes();
      }
    },
    setupScreenSizes() {
      this._setupScreenSizes(this);
      this.$nextTick(() => {
        this.manageScroll();
      });
    },
    manageScroll() {},
    searchWithAI(location) {
      this.logEvent("openAISearchFromItems" + location);
      let path = "/ai-conversations/new";
      if (this.search) {
        path += `?search=${encodeURIComponent(this.search)}`;
      }
      this.routePathRedirect({ path });
    },
    openSection(item) {
      this.getAndUpdateRecentSearches(item);
      if (item.path) {
        return this.routePathRedirect({
          path: item.path,
        });
      } else if (item.category == 7) {
        this.openCalculatorById({ id: item.id });
      } else if (item.topic) {
        this.openTopicItem({ itemId: item.id, redirectMode: true });
      } else {
        this.openItemOrProduct(item);
      }
    },
  },
};
</script>
